// extracted by mini-css-extract-plugin
export default {"buttonSizeContainer":"faqSize_buttonSizeContainer__GbfJD","buttonSize":"faqSize_buttonSize__TWeZZ","selected":"faqSize_selected__hfzfh"};